import translator from '@/locales';

export default function getDraftAppStateText(state) {
  const stateTranslation = {
    U: translator.t('APPS.DRAFT.STEPS.UPLOAD_FILES'),
    B: translator.t('APPS.DRAFT.STEPS.BASIC_INFO'),
    A: translator.t('APPS.DRAFT.STEPS.APP_INFO'),
    I: translator.t('APPS.DRAFT.STEPS.SUPPORT_INFO'),
    M: translator.t('APPS.DRAFT.STEPS.APP_MEDIA'),
    F: translator.t('APPS.DRAFT.STEPS.FINAL_CHECK_SIDEBAR_TITLE'),
  };

  return stateTranslation[state];
}
